import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "magento_adobeioeventsclient"
    }}>{`Magento_AdobeIoEventsClient`}</h1>
    <p>{`Welcome to the Magento Adobe IO Events integration repository!`}</p>
    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <p>{`Adobe IO Events is a package that enables integration between Magento and Adobe IO Events to create custom Event
Provider and custom Events Metadata.`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p>{`This is a two-step process:`}</p>
    <ol>
      <li parentName="ol">{`We will create an Event Provider, this is required once per Adobe Commerce instance`}</li>
      <li parentName="ol">{`We will update the Events Metadata, this should happen during the deployment phase`}</li>
    </ol>
    <h3 {...{
      "id": "configure-adobe-commerce-for-io-events"
    }}>{`Configure Adobe Commerce for IO Events`}</h3>
    <p>{`Depending on credential type complete steps for `}<inlineCode parentName="p">{`OAuth Server-to-Server`}</inlineCode>{` or `}<inlineCode parentName="p">{`Service Account (JWT) DEPRECATED`}</inlineCode></p>
    <h4 {...{
      "id": "oauth-server-to-server"
    }}>{`OAuth Server-to-Server`}</h4>
    <ol>
      <li parentName="ol">{`In the Adobe Developer Console, download your Adobe IO Console workspace configuration.`}</li>
      <li parentName="ol">{`In the Commerce admin panel, navigate to Stores > Settings > Configuration > Adobe Services > Adobe I/O Events > General configuration and make the following changes:`}
        <ul parentName="li">
          <li parentName="ul">{`Select `}<inlineCode parentName="li">{`OAuth (recommended)`}</inlineCode>{` as  `}<inlineCode parentName="li">{`Adobe I/O Authorization Type`}</inlineCode></li>
          <li parentName="ul">{`Populate the `}<inlineCode parentName="li">{`Adobe I/O Workspace Configuration`}</inlineCode>{` fields`}</li>
          <li parentName="ul">{`Enter a unique ID  in the `}<inlineCode parentName="li">{`Adobe Commerce Instance ID`}</inlineCode>{` field`}</li>
        </ul>
      </li>
    </ol>
    <h4 {...{
      "id": "service-account-jwt-deprecated"
    }}>{`Service Account (JWT) DEPRECATED`}</h4>
    <ol>
      <li parentName="ol">{`In the Adobe Developer Console, download your Adobe IO Console workspace configuration and its associated Service Account private key.`}</li>
      <li parentName="ol">{`In the Commerce admin panel, navigate to Stores > Settings > Configuration > Adobe Services > Adobe I/O Events > General configuration and make the following changes:`}
        <ul parentName="li">
          <li parentName="ul">{`Select `}<inlineCode parentName="li">{`JWT`}</inlineCode>{` as  `}<inlineCode parentName="li">{`Adobe I/O Authorization Type`}</inlineCode></li>
          <li parentName="ul">{`Populate the `}<inlineCode parentName="li">{`Service Account Private Key`}</inlineCode>{` and `}<inlineCode parentName="li">{`Adobe I/O Workspace Configuration`}</inlineCode>{` fields`}</li>
          <li parentName="ul">{`Enter a unique ID  in the `}<inlineCode parentName="li">{`Adobe Commerce Instance ID`}</inlineCode>{` field`}</li>
        </ul>
      </li>
    </ol>
    <h4 {...{
      "id": "create-event-provider"
    }}>{`Create Event Provider`}</h4>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Run the following command to create an event provider`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`bin/magento events:create-event-provider --label "<unique_provider_label>" --description "<provider description>"
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Enter the Event Provider ID output by the command in the `}<inlineCode parentName="p">{`Adobe I/O Event Provider ID`}</inlineCode>{` field`}</p>
      </li>
    </ol>
    <h2 {...{
      "id": "update-events-metadata"
    }}>{`Update Events Metadata`}</h2>
    <p>{`Events Metadata in the following format can optionally be stored in `}<inlineCode parentName="p">{`app/etc/event-types.json`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "events": [
        {
            "event_code": "com.adobe.commerce.product.created",
            "label": "Product created",
            "description": "A product was created in your catalog"
        },
        {
            "event_code": "my.custom.event.code",
            "label": "Custom event",
            "description": "custom event"
        }
    ]
}
`}</code></pre>
    <p>{`To update the metadata using the `}<inlineCode parentName="p">{`app/etc/event-types.json`}</inlineCode>{` file, add the following step to your `}<inlineCode parentName="p">{`ece-tool`}</inlineCode>{` or deployment script:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`bin/magento events:sync-events-metadata
`}</code></pre>
    <h2 {...{
      "id": "delete-events-metadata"
    }}>{`Delete Events Metadata`}</h2>
    <p>{`You can alternatively delete the Events Metadata no longer required by adding the `}<inlineCode parentName="p">{`--delete`}</inlineCode>{` option to the command as such:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`bin/magento events:sync-events-metadata --delete
`}</code></pre>
    <InlineAlert slots="text" mdxType="InlineAlert" />
The version of this module is 1.5.0.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      